import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as style from './BulkUploadCategorySingleDiff.styl';
function constructField(key, value, header, errorMap) {
    return (_jsxs("div", Object.assign({ className: "field" }, { children: [header, ": ", value || _jsx("em", { children: "None" }), errorMap[key] ? _jsx("span", Object.assign({ className: "error" }, { children: errorMap[key] })) : null] })));
}
export class BulkUploadCategorySingleDiff extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { diff } = this.props;
        const teamFieldString = diff.scopedExpenseTags.length ? diff.scopedExpenseTags.map((tag) => tag.name).join(', ') : '';
        // mappedValues may be undefined
        const mappedValueString = diff.mappedValues && diff.mappedValues.length ? diff.mappedValues.join(', ') : '';
        return (_jsxs("div", Object.assign({ className: style.global }, { children: [_jsx("em", Object.assign({ className: "identifier" }, { children: diff.categoryName })), _jsxs("div", Object.assign({ className: "fields" }, { children: [diff.parentCategoryName && constructField('parentCategoryName', diff.parentCategoryName, 'Parent Category', diff.fieldErrorMap), Boolean(teamFieldString) && constructField('scopedExpenseTags', teamFieldString, 'Scope to', diff.fieldErrorMap), Boolean(diff.mappedValues) && constructField('mappedValues', mappedValueString, 'Chart of Accounts', diff.fieldErrorMap)] })), _jsx("br", {})] })));
    }
}
